<template>
  <v-app>
    <v-app-bar
      app
      color="cyan lighten-3"
      dark
      height="45"
    >
      <div class="d-flex align-center">
        <v-img
          alt="Logo"
          class="shrink mr-2 mt-3"
          contain
          :src="require('./assets/logo-talk.png')"
          transition="scale-transition"
          width="70"
          style="transform: rotate(-5deg);"
        />
        <!-- src="@/assets/logo_wpb_bl.png" -->
        <!-- style="color: #8799ab;" -->

        <h1 style="color: #ebfafc;" v-if="!isMobile()">
          <span style="color: #4195A3">T</span>rain my 
          <span style="color: #4195A3">S</span>ocial 
          <span style="color: #4195A3">S</span>kills</h1>
        <h1 style="color: #ebfafc; font-size: 5vw;" v-else>
          <span style="color: #4195A3">S</span>ocial 
          <span style="color: #4195A3">S</span>kills
        </h1>
      </div>

      <v-spacer></v-spacer>

      <div id="nav">
        <!-- <router-link to="/" class="nav-home">Home <v-icon large>mdi-home</v-icon></router-link> -->
        <v-btn to="/" fab large color="#ff9d00" ><v-icon large>mdi-home</v-icon></v-btn>
      </div>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import store from '@/store'

export default {
  name: 'App',

  data: () => ({
    //
  }),
  watch:{
    $route: function() {
      if (this.$route.path == '/'){
        this.hskChoose(0)
      }
    }
  },
  methods: {
  isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
  },
  hskChoose(hskLevel) {
      store.commit("PAGE", hskLevel);
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #8799ab;
  /* color: #4195A3; */
  background-color: rgb(255, 255, 255);
  /* height: 90vh; */
  /* width: 90vw; */
  /* overflow: hidden; */
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #f0fcfc; 
  font-size: 2vw; 
  text-decoration: none;
}

#nav a:hover{
  color: #f4d4a1;
}
/* #nav a:hover .v-icon{
  color: #75c5dd;
} */

/* #nav a.router-link-active {
  color: #29a6cc;
} */

</style>